import PermissionGroupInterface from '../interfaces/PermissionGroupInterface';
import http from '../helpers/http';
import { DocumentsGroupPermissions } from '../views/pages/Documents/DocumentsStateManager';

const PermissionGroups = (token: string) => {
  return {
    list: async () => {
      const result = await http.get(`/permission-groups`, {
        headers: {
          'x-access-token': token,
        },
      });
      return (result?.data?.data || []) as PermissionGroupInterface[];
    },
    listPerModule: async (module: string) => {
      const result = await http.get(`/permission-groups/${module}`, {
        headers: {
          'x-access-token': token,
        },
      });
      return (result?.data?.data || []) as DocumentsGroupPermissions[];
    },
  };
};

export default PermissionGroups;
